const translateSizeToMaterialSize = (size)=>{
    switch(size){
        case 'small':
            return 'sm';
        case 'medium':
            return 'md';
        case 'large':
            return 'lg';
        default:
            return 'md';
    }
};
const translateSizeToCssValue = (width)=>{
    let adjustedWidth = Number(width) <= 1 && 0 !== width ? `${100 * Number(width)}%` : width;
    if (void 0 === adjustedWidth) adjustedWidth = '100%';
    else if ('number' == typeof adjustedWidth) adjustedWidth = `${adjustedWidth}px`;
    return adjustedWidth;
};
export { translateSizeToCssValue, translateSizeToMaterialSize };

//# sourceMappingURL=translate-size.js.map